import { Avatar } from '@mui/material'
import React from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import DataTableActions from '../../Common/dataTableActions/DataTableActions'
import { downloadSecureDocument } from '../../../api/download'
import styles from './styles/PatientHistoryMediasStyles'
import { PatientHistoryDownloadMediasProps } from './_props'

const useStyles = makeStyles(styles)

export const PatientHistoryDownloadMedias = ({ item, actType, type }: PatientHistoryDownloadMediasProps) => {
    const classes = useStyles()

    return (
        <div>
            <DataTableActions
                actions={[
                    {
                        onClick: async () => {
                            await downloadSecureDocument(
                                `${window._env_.REACT_APP_HDS_HOST}/archive/${
                                    actType === 'CONSULTATION' ? 'consultations' : 'transmissions'
                                }/${item.id}/medias/download`,
                                true,
                            )
                        },
                        icon: (
                            <Avatar
                                src={`/document-icons/${type}-trans.png`}
                                className={clsx(classes.small)}
                                variant="square"
                            />
                        ),
                    },
                ]}
            />
        </div>
    )
}
